import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import GroupIcon from "@mui/icons-material/Group";
import { PLATAFORMAS } from "config/constants";

export const benefits = [
  {
    icon: <FlashOnIcon fontSize="large" />,
    title: "Desenvolvimento Ágil",
    desc: "Sites institucionais, landing pages, portfólios, sistemas personalizados e lojas virtuais entregues com rapidez. Nossos templates são finalizados em até 15 dias. Para soluções personalizadas, consulte nossos prazos.",
  },
  {
    icon: <EmojiEventsIcon fontSize="large" />,
    title: "Qualidade Profissional",
    desc: "Design moderno, código otimizado e configuração completa de domínio e hospedagem. Garantimos uma experiência tranquila e segura para você.",
  },
  {
    icon: <GroupIcon fontSize="large" />,
    title: "Flexibilidade e Variedade",
    desc: `Oferecemos parcelamento em até 12x no cartão de crédito para todas as nossas soluções. Atuamos com sites, sistemas e lojas virtuais nas principais plataformas: ${PLATAFORMAS}.`,
  },
];
